const EDIT_AMOUNT_MONEY_FIELDS = `
  currency
  amount
  amountSoles
  amountDollars
  exchangeRate
`;

const EDIT_AMOUNT_WARNING_FIELDS = `
  code
  message
  serviceId
  ticketId
`;

const EDIT_AMOUNT_SERVICE_FIELDS = `
  id
  total
  moneda
  editOperation
  newTotalCostoSoles
  newTotalCostoDolares
`;

const EDIT_AMOUNT_TICKET_FIELDS = `
  id
  total
  moneda
  editOperation
  newTotalCostoSoles
  newTotalCostoDolares
`;

const EDIT_AMOUNT_RESULT_FIELDS = `
  ok
  serviceId
  ticketId
  updatedServiceIds
  money { ${EDIT_AMOUNT_MONEY_FIELDS} }
  serviceTotal { ${EDIT_AMOUNT_MONEY_FIELDS} }
  itineraryId
  itineraryCostDeltaDollars
  warnings { ${EDIT_AMOUNT_WARNING_FIELDS} }
  services { ${EDIT_AMOUNT_SERVICE_FIELDS} }
  ticket { ${EDIT_AMOUNT_TICKET_FIELDS} }
`;

export const EDIT_SERVICE_AMOUNT_MUTATION = `
  mutation EditServiceAmount($input: EditServiceAmountInput!) {
    editServiceAmount(input: $input) {
      ${EDIT_AMOUNT_RESULT_FIELDS}
    }
  }
`;

export const EDIT_TICKET_AMOUNT_MUTATION = `
  mutation EditTicketAmount($input: EditTicketAmountInput!) {
    editTicketAmount(input: $input) {
      ${EDIT_AMOUNT_RESULT_FIELDS}
    }
  }
`;
